import React from 'react'

const WalletCashback = () => {
  return (
    <div>WalletCashback</div>
  )
}

export default WalletCashback